/* ================================================== */
/* UTILS → download
/* ================================================== */

$(document).ready(function(){

	$('.download a, .download__link').click(function(e) {
		e.preventDefault();
		$('#download-form-' + $(this).attr('data-index')).submit();
	});

});